
import {finalize} from 'rxjs/operators';
import { Injectable, Optional } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as _ from 'lodash';
import { Router } from '@angular/router';
import { LoadingSpinnerService } from '../services/loading-spinner/loading-spinner.service';

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {

  constructor(private _service: LoadingSpinnerService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this._service.setLoading(true);
    return next.handle(request).pipe(
      finalize(() => this._service.setLoading(false)));
  }
}
